import { render, staticRenderFns } from "./DailyReportsTable.vue?vue&type=template&id=0472df81&"
import script from "./DailyReportsTable.vue?vue&type=script&lang=js&"
export * from "./DailyReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports